<template>
	<div id="seat_selection" class="seat_selection" >
		<div class="seat_selection_content container">
			<SectionHeader topText="2023 season ticket holder" bottomText="seat selection" />
			<div class="inner-container">
				<div class="header">
					<!-- <h5>buy seats</h5> -->
					<p>
						Cubs season tickets can be purchased starting at your designated appointment time through <a href="https://mlb.tickets.com/?agency=MLB_MPV&orgid=5#/auth/login" target="_blank">My Cubs Tickets</a>.
						During your appointment time, which will occur in late January or early February, you also may visit Wrigley Field to view available seats in person and purchase from your mobile device.
						Your appointment date and time to purchase 2023 season tickets was first communicated the week of December 12th in an email from your dedicated representative.
						<!-- Your appointment date and time to purchase 2023 season tickets will be communicated via email in late December. -->
					</p>
				</div>
				<div class="content">
					<div class="ticket_finder_section_1 buying_options">
						<img :src="require(`@/assets/images/icons/seatselection_cubstickets.svg`)" alt="">
						<div>
							<h3>buy seats through</h3>
							<h2>my cubs tickets</h2>
						</div>
					</div>
					<div class="ticket_finder_section_2 buying_options">
						<img :src="require(`@/assets/images/icons/seatselection_wringlyfield.svg`)" alt="">
						<div>
							<h3>buy seats at</h3>
							<h2>wrigley field</h2>
						</div>
					</div>
				</div>
				<a href="https://mlb.tickets.com/?agency=MLB_MPV&orgid=5#/auth/login" class="ticket_btn" target="_blank">My Cubs Tickets</a>
				<a href="https://www.mlb.com/cubs/tickets/season-tickets/waiting-list/guide" class="ticket_btn" target="_blank">Step-by-Step Purchasing Guide</a>
				<div class="guide_disclaimer">
					<p>
						Please click the button above to view a step-by-step guide for the online purchasing process. We encourage you to test your login credentials at least 24 hours before your scheduled appointment time.
					</p>
				</div>
				<div class="disclaimer_content">
					You can purchase a maximum of six (6) seats per new season ticket account, pending availability. Due to high demand and limited inventory, season ticket seats may not be available in all sections of the ballpark, and there is no guarantee seats will be available during your appointment time. We encourage you to act quickly at the start of your seat selection appointment as seats are available on a first-come, first-served basis. In the event there are no remaining season ticket locations available during your appointment time, you will retain your position on the Cubs Season Ticket Holder Waiting List. If season ticket seats are available and you decline to purchase, you will be removed from the Cubs Season Ticket Holder Waiting List. Please note if you are unable to purchase during your appointment time, your online login capability will remain active until the purchasing deadline.
					<br/><br/>
					If you have any questions during the seat selection process or need assistance, please contact your Cubs representative directly or our season ticket hotline at <a href="tel:773-404-4195">773-404-4195</a>.


				</div>
				<div class="additional-header">
					<h3>IF YOU PLAN TO VISIT WRIGLEY FIELD DURING YOUR APPOINTMENT TIME, PLEASE SEE ADDITIONAL DETAILS BELOW:</h3>
				</div>
				<div class="content additional-content">

					<div class="additional_details buying_options">
						<img :src="require(`@/assets/images/icons/parking.svg`)" alt="">
						<div>
							<h2>Parking</h2>
							<p>Complimentary parking is available in the Toyota Camry Lot located at  <span>1126 W. Grace St. Chicago, IL 60613 </span> (one block north of Waveland Ave).</p>
						</div>
					</div>
					<div class="additional_details buying_options">
						<img :src="require(`@/assets/images/icons/check-box.svg`)" alt="">
						<div>
							<h2>Check-in</h2>
							<p>Upon arrival, enter the ballpark through the double-glass doors marked <span>“Suite &amp; Club Entry,”</span> located near Clark and Addison streets between the ticket windows and the Wrigley Field Marquee. Up to three (3) guests may accompany you for your appointment.</p>
						</div>
					</div>
				</div>
				<span>Accounts that purchase season tickets in-person will receive a gift to welcome them to the Cubs Season Ticket Holder Family (one gift per account).</span>

			</div>

		</div>
		<divider img_src="second-divider.png" author="Marcus Stroman"   quote=" “There’s no better environment to play baseball in than Wrigley.
		No debate. Shout to the best fans in the league for bringing that positive energy each and every day.” "/>
	</div>
</template>
<script>
import SectionHeader from "@/components/SectionHeader";
import divider from "@/components/divider";

export default {
	name: "seat_selection",
	components: { SectionHeader, divider },
};

</script>
<style lang="scss" scoped>
.seat_selection {
	// background-image: url("~images/account/bg.jpeg");
	background-color: theme-var($--ch-theme-background-secondary);
	background-image: url("~images/bgImage.jpg");
	background-size: cover;


	@include media-breakpoint-down(sm) {
		background-image: url("~images/bgImage_mobile.jpg");
		// background-size:cover;
	}
	&_content {
		align-items: center;
		z-index: 1;
		height: 100%;
		padding: 150px 100px 60px 120px;
		//
		@include media-breakpoint-down(sm) {
			padding: 150px 30px 60px 30px;
		}
		@include media-breakpoint-only(md) {
			padding: 150px 30px 60px 30px;
		}
		.inner-container{
			margin: 50px auto;
			// padding: 0px 130px;
			@include media-breakpoint-down(sm) {
				padding: 0px 10px;
			}
			.header{

				display: flex;
				flex-direction: column;
				gap: 15px;
				background: #FFFFFF;
				padding: 30px;
				box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
				h5{
					margin-bottom:0px;
					// font-size: 20px;
					color: #0E3386;
					font-family: 'Verlag';
					font-style: normal;
					font-weight: 450;
					font-size: 16px;
					line-height: 145%;
					/* or 23px */

					text-transform: uppercase;
					@include media-breakpoint-down(sm) {
						font-size: 14px;
					}
				}
				p{
					font-family: 'Verlag Light';
				    font-style: normal;
				    font-weight: 325;
				    font-size: 18px;
				    line-height: 145%;
				    padding-top: 0px;
				    color: #000;
					@include media-breakpoint-down(sm) {
						font-size: 12px;
					}
				}
				a{
					font-family: 'Verlag Book';
				    font-style: normal;
				    font-weight: 625;
				    font-size: 18px;
				    line-height: 145%;
				    padding-top: 0px;
					text-decoration:none;
				    color: #000 !important;
				}
			}

		}
		.ticket_btn{
			padding: 8px 60px;
			background: #0E3386;
			border-radius: 55px;
			font-family: 'Verlag Book';
			font-style: normal;
			font-weight: 325;
			font-size: 20px;
			line-height: 24px;
			text-decoration:none;
			margin-right: 20px;
			color:white !important;

			&:hover{
				background: #CC3433;
			}
			@include media-breakpoint-down(sm) {
				display:flex;
				justify-content:center;
			}

		}
		.content{
			display: flex;
			flex-direction: row;
			gap: 15px;
			padding: 30px 0px;
			@include media-breakpoint-down(sm) {
				flex-direction: column;
			}
			@include media-breakpoint-only(md) {
				flex-direction: column;
			}
			@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
				flex-direction: column;
			}

			.buying_options{
				display: flex;
				flex-direction: row;
				justify-content:center;
				width:100%;
				background: #0B2255;
				padding: 30px;
				box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
				@include media-breakpoint-down(sm) {
					flex-direction: column;
				}
				h2{
					font-family: 'Verlag Condensed Bold';
					font-style: normal;
					font-weight: 400;
					font-size: 35px;
					line-height: 90%;
					text-align: center;
					text-transform: uppercase;
					color: #FFFFFF;
				}
				h3{
					font-family: 'Verlag Condensed Light';
					font-style: normal;
					font-weight: 300;
					font-size: 30px;
					line-height: 100%;
					text-align: center;
					text-transform: uppercase;
					color: #FFFFFF;
				}
				img{
					width: 60px;
					margin-right: 50px;
					@include media-breakpoint-down(sm) {
						margin: 10px auto;
					}
				}

			}
			.additional_details{
				background: #fff ;
				align-items: flex-start;
				h3{
					color: #0B2255;
					text-align:left;
				}
				h2{
					color: #0B2255;
					text-align:left;
					margin: 5px 0px;
				}
				img{
					margin-right: 15px;
					@include media-breakpoint-down(sm) {
						margin: 10px 0px 10px 0px;
					}
				}
				p{
					font-family: 'Verlag Light';
				    font-style: normal;
				    font-weight: 625;
				    font-size: 18px;
				    line-height: 145%;
				    padding-top: 5px;
					span{
						font-family: 'Verlag Book';
					}
				}

			}
		}
		.additional-content{

			padding: 10px 0px;
		}
		span{
			font-family: 'Verlag Book';
			font-style: normal;
			font-weight: 425;
			font-size: 18px;
			line-height: 145%;
			// padding-top: 5px;
		}
		.additional-header{
			h3{
				font-family: 'Verlag Condensed Book';
				font-style: normal;
				font-weight: 300;
				font-size: 24px;
				line-height: 100%;
				text-align: center;
				text-transform: uppercase;
				color: #0B2255;
				padding-bottom:10px;
			}
		}
		.disclaimer_content{
			margin:30px 0px;
			font-family: 'Verlag Condensed Light';
			font-style: normal;
			font-weight: 625;
			font-size: 18px;
			line-height: 145%;
			padding-top: 0px;
		}
		.guide_disclaimer{
			margin: 20px 0px 30px 0px;
			font-family: 'Verlag Condensed Bold';
			font-style: normal;
			font-weight: 625;
			font-size: 18px;
			line-height: 145%;
			padding-top: 0px;
		}
	}
}
</style>
